import { render } from "./LbrxDisplayHeader.vue?vue&type=template&id=0c2d3870&scoped=true"
import script from "./LbrxDisplayHeader.vue?vue&type=script&lang=js"
export * from "./LbrxDisplayHeader.vue?vue&type=script&lang=js"

import "./LbrxDisplayHeader.vue?vue&type=style&index=0&id=0c2d3870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2d3870"]])

export default __exports__